"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const axios_1 = __importDefault(require("axios"));
const react_toastify_1 = require("react-toastify");
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../../Auth/utils");
const permissions_1 = require("../../types/permissions");
const LabelConfirmationGridEditor = (0, react_1.forwardRef)((props, ref) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const setValue = props.setValue;
    const refInput = (0, react_1.useRef)(null);
    const { user } = (0, AuthContext_1.useAuth)();
    const Errors = ({ errors }) => {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'flex items-center' },
                react_1.default.createElement("div", { className: "Toastify__toast-icon Toastify--animate-icon Toastify__zoom-enter" },
                    react_1.default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: "var(--toastify-icon-color-error)" },
                        react_1.default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }))),
                react_1.default.createElement("div", { className: 'text-gray-800 leading-6' }, "Etikettendaten k\u00F6nnen nicht verifiziert werden!")),
            react_1.default.createElement("div", { className: 'ml-2 mt-2' },
                react_1.default.createElement("ul", { className: 'list-inside list-disc text-sm leading-4 space-y-2' }, Object.entries(errors)
                    .map(([field, fieldErrors]) => {
                    return fieldErrors.map((errorMessage, i) => (react_1.default.createElement("li", { key: i }, errorMessage)));
                })))));
    };
    const checkedHandler = async (event) => {
        let checked = event.target.checked;
        if (!(0, utils_1.isAllowed)(user, [permissions_1.GridPermissions.CONFIRM_LABEL])) {
            return;
        }
        try {
            setLoading(true);
            const plantOptionsApi = new api_1.PlantOptionApi();
            const { success, changes } = await plantOptionsApi.checkLabel(props.data.id, checked);
            if (success) {
                setValue(checked);
                const update = changes.forEach(change => {
                    const rowNode = props.api.getRowNode(change.id);
                    for (const [column, value] of Object.entries(change)) {
                        if ('checked' !== column && props.api.getColumnDef(column) !== null) {
                            if ('checked' == column) {
                                rowNode.setDataValue(column, value == true ? 1 : 0);
                            }
                            else {
                                rowNode.setDataValue(column, value);
                            }
                        }
                    }
                });
            }
        }
        catch (error) {
            if (axios_1.default.isAxiosError(error)) {
                if (error.response && error.response.status) {
                    if (error.response.status === 422) {
                        react_toastify_1.toast.error(react_1.default.createElement(Errors, { errors: error.response.data.errors }), {
                            autoClose: 7000,
                            icon: false,
                        });
                    }
                    else {
                        (0, errorNotification_1.notifyError)(error.response.data.message);
                    }
                }
            }
            else {
                (0, errorNotification_1.notifyError)(error);
            }
        }
        finally {
            setLoading(false);
        }
    };
    /* Component Editor Lifecycle methods */
    (0, react_1.useImperativeHandle)(ref, () => {
        return {
            // the final value to send to the grid, on completion of editing
            getValue() {
                return props.value;
            },
            // Gets called once before editing starts, to give editor a chance to
            // cancel the editing before it even starts.
            isCancelBeforeStart() {
                return false;
            },
        };
    });
    return (react_1.default.createElement("div", { className: 'h-full flex items-center' }, loading ? (react_1.default.createElement("svg", { className: "animate-spin h-4 w-4 text-primary-600", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
        react_1.default.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
        react_1.default.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))) : (react_1.default.createElement("input", { type: "checkbox", className: 'text-primary-500', ref: refInput, checked: props.value, onChange: checkedHandler }))));
});
exports.default = LabelConfirmationGridEditor;
